import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { PageLayout } from 'src/components/shared/PageLayout';

const CatalogLoadingFailed: React.FC = () => {
  const { t } = useTranslation(['catalog', 'translation']);
  return (
    <PageLayout
      title={t('top')}
      color="#faee89"
      backLabel={t('translation:aria_button_back_to_previous')}
    >
      <LoadingFailed error="unstable-network" />
    </PageLayout>
  );
};

const CatalogLoading: React.FC = () => {
  const { t } = useTranslation(['translation']);
  return (
    <PageLayout
      title={t('catalog')}
      color="#faee89"
      background="transparent"
      backLabel={t('translation:aria_button_back_to_previous')}
    >
      <Loading />
    </PageLayout>
  );
};

const Catalog = React.lazy(() => import('./Catalog'));

export default class extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }
  public render() {
    if (this.state.hasError) {
      return <CatalogLoadingFailed />;
    } else {
      return (
        <Suspense fallback={<CatalogLoading />}>
          <Catalog />
        </Suspense>
      );
    }
  }
}
